module.exports = __webpack_public_path__ + "static/media/RI-D3-8.5-052.ad77225d.webp";